import { useCallback } from 'react';
import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { useInboxNavigate } from '@frontend/inbox-navigation';
import { useSmsTagNotification } from '@frontend/notifications';
import { GetWebsocketEventHandler, useWebsocketEventSubscription } from '@frontend/websocket';

/**
 * A hook that returns a function to execute when a manual scheduled SMS event is received.
 * This doesn't have any WebSocket subscription logic, just the handler. Useful for testing.
 */
export const useSMSTagNotificationWSHandler = () => {
  const { navigateToThread } = useInboxNavigate();
  const { create } = useSmsTagNotification({
    onView: (event) => {
      navigateToThread({
        threadId: event.payload.threadId,
        groupId: event.payload.groupId,
        personId: event.payload.personId,
        smsId: event.payload.smsId,
        smsCreatedAt: event.payload.smsCreatedAt,
      });
    },
  });

  const eventHandler = useCallback<GetWebsocketEventHandler<NotificationType.SMS_TAG_V2>>(
    (event) => {
      const {
        params: { action },
      } = event;

      switch (action) {
        case 'tagApplied':
          create({
            id: String(event.id),
            type: 'sms-tag',
            payload: event.params,
            timestamp: Date.now(),
            state: {
              paused: false,
              status: 'unread',
            },
          });
      }
    },
    [create]
  );

  return eventHandler;
};

export const useSMSTagNotificationSubscription = () => {
  const handler = useSMSTagNotificationWSHandler();
  return useWebsocketEventSubscription(NotificationType.SMS_TAG_V2, handler);
};
